import { Result } from '@/main/models/common/resultResponse';
import {
  DirectAssignRequest,
  QuoteSupplierItemImageDeleteRequest,
  QuoteSupplierItemPartRequest,
  QuoteSupplierItemSaveCartRequest,
  QuoteSupplierItemUpdateQuantityRequest,
  QuoteSupplierItemUploadImageRequest,
  QuoteSupplierRemoveCartRequest
} from '@/main/models/request';
import {
  QuoteSupplierItemPartResponse,
  QuoteSupplierItemResponse,
  QuoteSupplierItemSaveCartResponse,
  SaveQuoteSupplierItemImageResponse,
  SearchNAGSCodeResponse
} from '@/main/models/response';
import { TimeoutRequestConfigurationEnum } from '@/main/services/enum/TimeoutRequestConfigurationEnum';
import { AxiosResponse } from 'axios';
import { IQuoteSupplierItemApi, api } from '../base';
import { apiIntegration } from '../base/apiIntegration';
import { isNullUndefined } from '@/main/services/reducerUtils';

const baseRoute: string = 'QuoteSupplierItem';

export class QuoteSupplierItemApi extends IQuoteSupplierItemApi {
  saveCart(
    request: QuoteSupplierItemSaveCartRequest
  ): Promise<AxiosResponse<Result<QuoteSupplierItemSaveCartResponse>, any>> {
    return api.post(`${baseRoute}/savecart`, request);
  }
  deleteCart(
    request: QuoteSupplierRemoveCartRequest
  ): Promise<AxiosResponse<Result<QuoteSupplierItemSaveCartResponse>>> {
    return api.delete(`${baseRoute}/removefromcart`, { params: request });
  }
  getParts(
    request: QuoteSupplierItemPartRequest
  ): Promise<AxiosResponse<Result<QuoteSupplierItemPartResponse[]>, any>> {
    return api.get(`${baseRoute}/getparts`, {
      params: request,
      timeout: TimeoutRequestConfigurationEnum.FiveMinutesInMilliseconds
    });
  }
  searchNAGSCode(
    guidQuote: string
  ): Promise<AxiosResponse<Result<SearchNAGSCodeResponse>>> {
    return apiIntegration.get('Nags', { params: { quoteGuid: guidQuote } });
  }
  save(
    request: QuoteSupplierItemPartRequest[]
  ): Promise<AxiosResponse<Result<any>, any>> {
    return api.post(`${baseRoute}/save`, request);
  }
  async updatequantitypart(
    request: QuoteSupplierItemUpdateQuantityRequest
  ): Promise<AxiosResponse<Result<QuoteSupplierItemPartResponse>>> {
    const resposnse = await api.post(
      `${baseRoute}/updatequantitypart`,
      request
    );
    return resposnse;
  }
  clearAllCart(guidQuote: string): Promise<AxiosResponse<Result<any>, any>> {
    return api.delete(`${baseRoute}/clearallcart`, { params: { guidQuote } });
  }
  getWarehouseDeliversBySupplier(
    guidWarehouse: string,
    guidQuote: string
  ): Promise<AxiosResponse<Result<boolean>, any>> {
    return api.get(`${baseRoute}/getwarehousedeliversbysupplier`, {
      params: { guidWarehouse, guidQuote }
    });
  }
  saveBuyerPartAsnwer(
    request: DirectAssignRequest
  ): Promise<AxiosResponse<Result<QuoteSupplierItemResponse>>> {
    return api.post(`${baseRoute}/SaveBuyerPartAsnwer`, request, {
      timeout: TimeoutRequestConfigurationEnum.ThreeMinutesInMilliseconds
    });
  }

  saveBuyerPartAsnwerClaim(
    request: DirectAssignRequest
  ): Promise<AxiosResponse<Result<QuoteSupplierItemResponse>>> {
    return api.post(`${baseRoute}/SaveBuyerPartAsnwerByClaim`, request, {
      timeout: TimeoutRequestConfigurationEnum.ThreeMinutesInMilliseconds
    });
  }

  uploadImage(
    request: QuoteSupplierItemUploadImageRequest
  ): Promise<AxiosResponse<Result<SaveQuoteSupplierItemImageResponse>>> {
    const { guidQuoteItem, guidQuoteSupplierItem, images, idPartType } =
      request;

    const formData = new FormData();

    if (!isNullUndefined(guidQuoteSupplierItem)) {
      formData.append('guidQuoteSupplierItem', guidQuoteSupplierItem);
    } else if (
      !isNullUndefined(guidQuoteItem) &&
      !isNullUndefined(idPartType)
    ) {
      formData.append('guidQuoteItem', guidQuoteItem);
      formData.append('idPartType', String(idPartType));
    }

    images.forEach(image => {
      formData.append('images', image);
    });

    return api.post(`${baseRoute}/UploadImage`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  deleteImage(guids: string[]): Promise<AxiosResponse<Result<boolean>>> {
    return api.post(`${baseRoute}/DeleteImage`, guids);
  }
}
